import Tabs from './components/Tabs';
import Login from './components/Login';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ThemeProvider } from './contexts/ThemeContext';
import { ApiProvider } from './contexts/ApiContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { UserChatProvider } from './contexts/UserChatContext';
import { UserChatSidebar } from './components/UserChat/UserChatSidebar';
import PWAInstallPrompt from './components/PWAInstallPrompt';

// Solo desactivar autenticación en desarrollo local si se configura explícitamente
const DISABLE_AUTH = import.meta.env.DEV && import.meta.env.VITE_DISABLE_AUTH === 'true';

function AppContent() {
  const { isAuthenticated, loading } = useAuth();

  // BYPASS SOLO EN DESARROLLO LOCAL - Siempre mostrar la app sin login
  if (DISABLE_AUTH) {
    return (
      <div className="app">
        <div style={{ padding: '10px', background: '#ffeb3b', color: '#000', textAlign: 'center', fontWeight: 'bold' }}>
          ⚠️ MODO DEBUG LOCAL: Autenticación deshabilitada
        </div>
        <Tabs />
      </div>
    );
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Cargando...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <div className="app">
      <Tabs />
      <UserChatSidebar />
      <PWAInstallPrompt />
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <ApiProvider>
          <AuthProvider>
            <ToastProvider>
              <NotificationProvider>
                <UserChatProvider>
                  <AppContent />
                </UserChatProvider>
              </NotificationProvider>
            </ToastProvider>
          </AuthProvider>
        </ApiProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;

